import { Globals } from "../CoreApp/Globals";

export function PollForNotifications() {
  var nMgr = Globals._wsMgr.GetNotificationMgr();
  if (nMgr == null) return;

  if (nMgr.IsActivePoll()) return;

  nMgr.SendNextPoll();
}
